<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: GCI 2020
      Author: Dtsmart
    Author URL: http://dtsmart.vn
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>To get supports, navigate to <a href="http://support.fastboy.net" target="_blank" rel="nofollow">Support page</a>, Thank you!</span>
        
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
